module.exports = __webpack_public_path__ + "static/images/share_btn.a79c92b.png";